export default {
      id: "icon-clock-usage",
      viewBox: "0 0 14 14",
      url: __webpack_public_path__ + "icons.svg#icon-clock",
      toString: function () {
        return this.url;
      }
    }